import { useLocation } from 'react-router-dom';
import { usePackages } from '../../hooks/react-query/use-package';
import Loader from '../shared/loader';
import Error from '../shared/error';
import { APIErrorType } from '../../api';
import { CartProvider } from '../../context/cart/provider';
import Store from './store';
import Segment from '../shared/segment';
import { DEFAULT_PKG, DEFAULT_TYPE_ID } from './constants';

function StoreContainer() {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  if (location.search == '') {
    searchParams.set('type', DEFAULT_TYPE_ID);
    searchParams.set('package', DEFAULT_PKG);
  }

  const { isLoading, isError, error, data: packages } = usePackages(searchParams.toString());
  if (isError) return <Error error={error as APIErrorType} />;
  if (isLoading) return <Loader />;
  if (!packages || packages.length === 0)
    return <Segment textAlign='center'>بسته‌ای برای فروش یافت نشد.</Segment>;

  return (
    <CartProvider>
      <Store packages={packages} />
    </CartProvider>
  );
}

export default StoreContainer;
